import { useUIContext } from 'state/ui';

export const useAppHeaderDimensions = () => {
  const { appHeaderDimensions, updateAppHeaderDimensions } = useUIContext();
  return { appHeaderDimensions, updateAppHeaderDimensions };
};
